// extracted by mini-css-extract-plugin
module.exports = {"reCatichWrapper":"Recaptcha_reCatichWrapper__pIvbo"};